import { EllipsisSpan, Table, Button, Form, Select } from '@maxtropy/components';
import { Col, Space } from 'antd';
import { ColumnType } from 'antd/es/table';
import { forwardRef, Ref, useImperativeHandle, useState } from 'react';
import { LeftNavPreferenceDisplay, OuStaffType } from '../../../../api/const';
import UserModal from './userModal';
import { StaffListResponse } from '../../../../api/customer';

export const columns: ColumnType<StaffListResponse>[] = [
  {
    title: '用户姓名',
    dataIndex: 'name',
    width: 200,
    render: (v: OuStaffType) => <EllipsisSpan value={v} />,
  },
  {
    title: '用户账号',
    dataIndex: 'username',
    width: 200,
    render: (v: OuStaffType) => <EllipsisSpan value={v} />,
  },
  {
    title: '手机号码',
    dataIndex: 'cellphone',
    width: 200,
    render: (v: OuStaffType) => <EllipsisSpan value={v} />,
  },
  {
    title: '所属组织',
    dataIndex: 'orgName',
    width: 200,
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];

// 定义暴露给父组件的类型
export interface UserRef {
  getValue: () => StaffListResponse[];
}

interface UserListProps {
  selectedMcid?: string;
  setSelectedMcid: (value: string) => void;
}

const UserList = forwardRef(({ selectedMcid, setSelectedMcid }: UserListProps, ref: Ref<UserRef>) => {
  const [visible, setVisible] = useState<boolean>();
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getValue: () => form.getFieldValue('staffList'),
  }));

  const buildColumns = [
    ...columns,
    {
      title: '左侧导航栏状态',
      dataIndex: 'navigationPreference',
      width: 200,
      render: (_: any, record: any, index: number) => (
        <Form.Item name={['staffList', index, 'navigationPreference']} style={{ margin: 0 }}>
          <Select
            placeholder="请选择"
            options={Object.entries(LeftNavPreferenceDisplay).map(([key, value]) => ({
              label: value,
              value: Number(key),
            }))}
          ></Select>
        </Form.Item>
      ),
    },
  ];

  return (
    <Form form={form}>
      <Space
        size={8}
        style={{
          marginBottom: 10,
          marginTop: 8,
        }}
      >
        <Button type="primary" onClick={() => setVisible(true)}>
          选择用户
        </Button>
      </Space>
      <Col span={24}>
        <Form.Item name="staffList" valuePropName="dataSource" style={{ margin: 0 }}>
          <Table rowKey={record => `${record.muid}-${record.orgId}`} columns={buildColumns} scroll={{ y: 200 }} />
        </Form.Item>
      </Col>
      {visible && (
        <UserModal
          onCancel={() => {
            setVisible(false);
          }}
          selectedData={form.getFieldValue('staffList') ?? []}
          setSelectedData={staffList => {
            form.setFieldsValue({ staffList });
          }}
          setSelectedMcid={setSelectedMcid}
          selectedMcid={selectedMcid}
        />
      )}
    </Form>
  );
});

export default UserList;
